var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoBlueMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 26,
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.16 0.415276L10.3104 4.87105L2.88258 8.32207C1.98495 8.73911 1.24297 9.43047 0.763651 10.2964L0.533661 10.712C-0.290688 12.2013 -0.150814 14.0381 0.889547 15.3855C1.50387 16.1811 2.37936 16.7342 3.36166 16.9474L10.4087 18.4765C11.0746 18.621 11.6503 19.0359 11.9979 19.6219L13.6234 22.3616C14.3457 23.5789 15.4624 24.5127 16.7884 25.0081L17.231 25.1734C19.0189 25.8414 21.027 25.5121 22.5079 24.3081C23.5172 23.4875 24.195 22.329 24.4158 21.0471L27.0843 5.55854C27.2461 4.61938 27.1168 3.65319 26.7138 2.78962L26.6893 2.73708C26.0001 1.26051 24.5914 0.249709 22.9719 0.0697423L22.6015 0.0285823C21.7677 -0.0640719 20.9244 0.069502 20.16 0.415276Z",
    fill: "#122A41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlueMobile);
export default __webpack_public_path__ + "static/media/logoBlue-mobile.8d626f299bc04d0a58d2358356a40320.svg";
export { ForwardRef as ReactComponent };